import React, { Component } from 'react';
import update from 'immutability-helper';
import Loading from '../Loading.js'
import FormList from '../../Fields/FormList.js'
import PersonalData from '../Tabs/PersonalData.js';
import { getFunctions, getSectors, getPersonRegions, 
    getPersonAttachments, getQuestions, getPersonWorkExperiences, 
    getPersonSalary,  getPersonEducations,  getJobLanguages, 
    getJobSkills,  getJobCompetences } from '../../Api/UserActions.js'
import { getSalaryPeriods } from '../../Api/Namezzz.js'
import { getDateString, getJsonDate, getJsonItem, isEmpty } from '../../Utilities/JsonFunctions.js'
import { getTranslation } from '../../Utilities/GetTranslation.js';
import { getWorkExperiencesFormList, getEducationsFormList, getObjectiveFunctionsFormList, getObjectiveSectorsFormList, getPersonRegionsFormList } from '../../Utilities/SnsFunctions.js';
import HtmlLegendTitle from '../../Fields/HtmlLegendTitle.js';

declare var globalSns;

class Overview extends Component {
    constructor(props) {
        super(props);
        
        this.state = {};

        this.cancel = this.cancel.bind(this);
        this.finish = this.finish.bind(this);
        this.print = this.print.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }
    
    // Load or reload the attachments
    loadData() {      
        getFunctions(globalSns.languageId, (data) => {
            this.setState({
                objectiveFunctions: data
            });
        });
        getSectors(globalSns.languageId, (data) => {
            this.setState({
                objectiveSectors: data
            })
        });
        getPersonRegions(globalSns.languageId, (data) => {
            this.setState({
                personRegions: data
            });
        });        
        getPersonAttachments(globalSns.languageId, globalSns.jobId, (data) => {
            this.setState({
                personAttachments: data
            });
        });
        getQuestions(globalSns.jobId, globalSns.languageId, (data) => {
            this.setState({
                questions: data
            });
        });
        getPersonWorkExperiences(globalSns.languageId, (data) => {
            this.setState({
                personWorkExperiences: data
            });
        });
        getSalaryPeriods(globalSns.languageId, (data) => {
            this.setState({
                salaryPeriods: data
            })
        });
        getPersonSalary((data) => {
            this.setState({
                personSalary: data
            });
        });        
        getPersonEducations(globalSns.languageId, (data) => {
            this.setState({
                personEducations: data
            });
        });
        getJobLanguages(globalSns.jobId, globalSns.languageId, (data) => {
            this.setState({
                jobLanguages: data
            });
        });
        getJobSkills(globalSns.jobId, globalSns.languageId, (data) => {
            this.setState({
                jobSkills: data
            });
        });
        getJobCompetences(globalSns.jobId, globalSns.languageId, (data) => {
            this.setState({
                jobCompetences: data
            });
        });        
    }

    cancel() {
        this.props.onCancel();
    }

    finish() {
        this.props.onFinish();
    }

    print() {
        window.print();
    }

    handleEdit(componentName, e) {
        e.preventDefault();

        let component;
        for (let step of this.props.steps) {
            if (step.id.toLowerCase() === componentName.toLowerCase()) {
                component = step;
                continue;
            }
        }

        var index = this.props.steps.indexOf(component);
        if (index > -1) {
            this.props.onGoToStep(index);
        }
    }

    render() {

        if (this.state.objectiveFunctions == null || this.state.objectiveSectors == null || this.state.personRegions == null
            || this.state.personAttachments == null || this.state.questions == null || this.state.personWorkExperiences == null
            || this.state.salaryPeriods == null || this.state.personSalary == null || this.state.personEducations == null 
            || this.state.jobLanguages == null || this.state.jobSkills == null || this.state.jobCompetences == null) {
            return (
                <Loading/>
            );
        }

        let questions = this.state.questions;

        if (this.props.job.isBusinessRegistration && this.props.job.hasSectorQuestion && this.state.objectiveSectors.length > 0) {
            var answer = this.state.objectiveSectors[0].sectorText;
            if (this.state.objectiveSectors.length > 1) {
                answer += "\n" + this.state.objectiveSectors[1].sectorText;
            }
            if (this.state.objectiveSectors.length > 2) {
                answer += "\n" + this.state.objectiveSectors[2].sectorText;
            }
            var branchQuestion = [{
                seqQuest: 0,
                quest: getTranslation("sns.webparts.questions.branches"),
                answer: answer
            }]

            questions = update(branchQuestion, {$push: questions});
        }

        var languages = [];
        for (var iLang = 0; iLang < this.state.jobLanguages.length; iLang++) {
            var language = this.state.jobLanguages[iLang];
            var itmLanguage = {
                id: language.id,
                text: 
                    <div>
                        <strong>{language.name}</strong>                            
                        <br/>{getTranslation('sns.webparts.capabilities.languages.talk')}: {language.talk}
                        <br/>{getTranslation('sns.webparts.capabilities.languages.read')}: {language.read}
                        <br/>{getTranslation('sns.webparts.capabilities.languages.write')}: {language.write}
                    </div> 
            };
            languages.push(itmLanguage);
        }

        var skills = [];
        for (var iSkill = 0; iSkill < this.state.jobSkills.length; iSkill++) {
            var skill = this.state.jobSkills[iSkill];
            var itmSkill = {
                id: skill.id,
                text:
                    <div>
                        <strong>{skill.skillText}</strong>: {skill.score}
                    </div>
            }
            skills.push(itmSkill);
        }

        var competences = [];
        for (var iCompetence = 0; iCompetence < this.state.jobCompetences.length; iCompetence++) {
            var competence = this.state.jobCompetences[iCompetence];
            var itmCompetence = {
                id: competence.id,
                text:
                    <div>
                        <strong>{competence.name}</strong>: {competence.score}
                    </div>
            }
            competences.push(itmCompetence);
        }

        let currentSalaryText = getJsonItem(this.state.salaryPeriods, "key", this.state.personSalary.currentSalaryPeriod).value;
        let preferredSalaryText = getJsonItem(this.state.salaryPeriods, "key", this.state.personSalary.preferredSalaryPeriod).value;

        return (
            <div className="overview">
                <h1>{getTranslation("sns.webparts.overview.title")}</h1>
                <div className="EditingFormTable table">
                    <div className="tr text-right col-md-8 button-wrapper hidden-print">
                        {globalSns.step == null ?
                            <input type="button" id="cancelbutton"
                                className="FormButton btn btn-primary prev"
                                value={getTranslation("sns.custom.jobapply.close")}
                                onClick={this.cancel} /> : ""
                        }                            
                        {globalSns.step == null ?
                            <input type="button" id="finishbutton"
                                className="FormButton btn btn-primary next"
                                value={getTranslation("sns.custom.jobapply.finish")}
                                onClick={this.finish} /> : ""
                        }
                        <a href="# " className="print" title={getTranslation("sns.custom.jobapply.print")} onClick={this.print}>
                            <span className="sr-only">{getTranslation("sns.custom.jobapply.print")}</span>
                            <i className="fa fa-print" aria-hidden="true"></i>
                        </a>
                    </div>                 
                    <PersonalData authenticated={true} readonly={true} showEdit={!this.props.job.mainState} onEdit={(e) => this.handleEdit("personaldata", e)} />
                    {
                        (!this.props.job.isBusinessRegistration && this.state.objectiveFunctions.length > 0) ?
                            <div className="printblock">
                                <HtmlLegendTitle title={getTranslation("sns.webparts.jobpreferences.cat-functions")} 
                                    readonly={this.props.job.mainState} onClick={(e) => this.handleEdit("jobpreferences", e)} />
                                <FormList values={getObjectiveFunctionsFormList(this.state.objectiveFunctions)} title={getTranslation("sns.webparts.workexperiences.selected")} isUserData={false} />
                            </div> : ""
                    }   
                    {
                        (!this.props.job.isBusinessRegistration && this.state.objectiveSectors.length > 0) ?
                            <div className="printblock">
                                <HtmlLegendTitle title={getTranslation("sns.webparts.jobpreferences.cat-sectors")} 
                                    readonly={this.props.job.mainState} onClick={(e) => this.handleEdit("jobpreferences", e)} />                            
                                <FormList values={getObjectiveSectorsFormList(this.state.objectiveSectors)} title={getTranslation("sns.webparts.workexperiences.selected")} isUserData={false} />
                            </div> : ""
                    }   
                    {
                        (!this.props.job.isBusinessRegistration && this.state.personRegions.length > 0) ?
                            <div className="printblock">
                                <HtmlLegendTitle title={getTranslation("sns.webparts.jobpreferences.cat-regions")} 
                                    readonly={this.props.job.mainState} onClick={(e) => this.handleEdit("jobpreferences", e)} />
                                <FormList values={getPersonRegionsFormList(this.state.personRegions)} title={getTranslation("sns.webparts.workexperiences.selected")} isUserData={false} />
                            </div> : ""
                    }   
                    {
                        (this.state.personAttachments.length > 0) ? 
                            <div className="printblock">
                                <HtmlLegendTitle title={getTranslation("sns.webparts.motivation.uploads")} 
                                    readonly={this.props.job.mainState} onClick={(e) => this.handleEdit((!this.props.job.isBusinessRegistration && globalSns.jobId > 0) ? "motivation" : "uploads", e)} />
                                <div className="tr table-wrapper">
                                    <strong>{getTranslation("sns.webparts.uploads.documents")}</strong>
                                    <table className="table table-condensed table-responsive">
                                        <tbody>
                                            {
                                                this.state.personAttachments.map((personAttachment) => 
                                                    <tr key={personAttachment.id}>
                                                        <td>{getDateString(getJsonDate(personAttachment.creDat))}</td>
                                                        <td>{personAttachment.category}</td>
                                                        <td><a href={personAttachment.url} target="_blank">{personAttachment.name}</a></td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>                                
                            </div> : ""
                    }                
                    {            
                        (questions.length > 0) ? 
                            <div className="printblock">
                                <HtmlLegendTitle title={getTranslation("sns.webparts.motivation.motivation")} 
                                    readonly={this.props.job.mainState} onClick={(e) => this.handleEdit((this.props.job.isBusinessRegistration) ? "project" : (globalSns.jobId === 0) ? "jobpreferences" : "motivation", e)} />
                                {
                                    questions.map((question) =>
                                        <div className="tr full-width printblock" key={question.seqQuest}>
                                            <div className="FieldLabel td">
                                                <label>{question.quest}</label>
                                            </div>
                                            <div className="EditingFormValueCell td">
                                                {
                                                    isEmpty(question.answer) ? "/" :
                                                        question.answer.split('\n').map((item, key) => {
                                                            return <span key={key}>{item}<br/></span>
                                                        })
                                                }
                                            </div>
                                        </div>
                                    )
                                }                               
                            </div> : ""
                    }
                    {
                        (!this.props.job.isBusinessRegistration && this.state.personWorkExperiences.length > 0) ?
                            <div className="printblock">
                                <HtmlLegendTitle title={getTranslation("sns.webparts.workexperiences.cat")} 
                                    readonly={this.props.job.mainState} onClick={(e) => this.handleEdit("workexperiences", e)} />                            
                                <FormList values={getWorkExperiencesFormList(this.state.personWorkExperiences)} title={getTranslation("sns.webparts.workexperiences.selected")} isUserData={false} />
                            </div> : ""
                    }
                    {
                        (!this.props.job.isBusinessRegistration && globalSns.jobId > 0 && this.state.personSalary.workExperience && 
                            (this.state.personSalary.currentSalary != null || this.state.personSalary.currentExtra != null)) ?
                            <div className="printblock">
                                <HtmlLegendTitle title={getTranslation("sns.webparts.salary.current")} 
                                    readonly={this.props.job.mainState} onClick={(e) => this.handleEdit("salary", e)} />
                                {
                                    (this.state.personSalary.currentSalary != null) ?
                                        <div className="tr form-inline">
                                            <div className="FieldLabel td">
                                                <label>{getTranslation("sns.webparts.salary.currentsalary")}</label>
                                            </div>
                                            <div className="EditingFormValueCell td">
                                                <p className="form-control-static">{this.state.personSalary.currentSalary}&nbsp;{getTranslation("sns.webparts.salary.period")}&nbsp;{currentSalaryText}</p>
                                            </div>
                                        </div> : ""
                                }
                                {
                                    (this.state.personSalary.currentExtra != null) ?
                                        <div className={"tr"}>
                                            <div className="FieldLabel td">
                                                <label>{getTranslation("sns.webparts.salary.current.extra")}
                                                </label>
                                            </div>
                                            <div className="EditingFormValueCell td">
                                                <p className="form-control-static">{this.state.personSalary.currentExtra}</p>
                                            </div>
                                        </div> : ""
                                }
                            </div> : ""
                    }
                    {
                        (!this.props.job.isBusinessRegistration && globalSns.jobId > 0 &&
                            (this.state.personSalary.preferredSalary != null || this.state.personSalary.preferredExtra != null)) ?
                            <div className="printblock">
                                <HtmlLegendTitle title={getTranslation("sns.webparts.salary.preferred")} 
                                    readonly={this.props.job.mainState} onClick={(e) => this.handleEdit("salary", e)} />
                                {
                                    (this.state.personSalary.preferredSalary != null) ?
                                        <div className="tr form-inline">
                                            <div className="FieldLabel td">
                                                <label>{getTranslation("sns.webparts.salary.preferredsalary")}</label>
                                            </div>
                                            <div className="EditingFormValueCell td">
                                                <p className="form-control-static">{this.state.personSalary.preferredSalary}&nbsp;{getTranslation("sns.webparts.salary.period")}&nbsp;{preferredSalaryText}</p>
                                            </div>
                                        </div> : ""
                                }
                                {
                                    (this.state.personSalary.preferredExtra != null) ?
                                        <div className={"tr"}>
                                            <div className="FieldLabel td">
                                                <label>{getTranslation("sns.webparts.salary.preferred.extra")}
                                                </label>
                                            </div>
                                            <div className="EditingFormValueCell td">
                                                <p className="form-control-static">{this.state.personSalary.preferredExtra}</p>
                                            </div>
                                        </div> : ""
                                }
                            </div> : ""
                    }                    
                    {
                        (!this.props.job.isBusinessRegistration && this.state.personEducations.length > 0) ?
                            <div className="printblock">
                                <HtmlLegendTitle title={getTranslation("sns.webparts.educations.cat")} 
                                    readonly={this.props.job.mainState} onClick={(e) => this.handleEdit("educations", e)} />
                                <FormList values={getEducationsFormList(this.state.personEducations)} title={getTranslation("sns.webparts.educations.selected")} isUserData={false} />                
                            </div> : ""
                    }
                    {
                        (!this.props.job.isBusinessRegistration && this.state.jobLanguages.length > 0) ?
                            <div className="printblock">
                                <HtmlLegendTitle title={getTranslation("sns.webparts.capabilities.languages")} 
                                    readonly={this.props.job.mainState} onClick={(e) => this.handleEdit("capabilities", e)} />
                                <FormList values={languages} title={getTranslation("sns.webparts.capabilities.languages.selected")} isUserData={false} />                
                            </div> : ""
                    }
                    {
                        (!this.props.job.isBusinessRegistration && this.state.jobSkills.length > 0) ?
                            <div className="printblock">
                                <HtmlLegendTitle title={getTranslation("sns.webparts.capabilities.skills")} 
                                    readonly={this.props.job.mainState} onClick={(e) => this.handleEdit("capabilities", e)} />
                                <FormList values={skills} title={getTranslation("sns.webparts.capabilities.skills.selected")} isUserData={false} />                
                            </div> : ""
                    } 
                    {
                        (!this.props.job.isBusinessRegistration && this.state.jobCompetences.length > 0) ?
                            <div className="printblock">
                                <HtmlLegendTitle title={getTranslation("sns.webparts.capabilities.competences")} 
                                    readonly={this.props.job.mainState} onClick={(e) => this.handleEdit("capabilities", e)} />                            
                                <FormList values={competences} title={getTranslation("sns.webparts.capabilities.competences.selected")} isUserData={false} />                
                            </div> : ""
                    } 
                    <div className="tr text-right col-md-8 button-wrapper hidden-print">
                        {globalSns.step == null ?
                            <input type="button" id="cancelbutton"
                                className="FormButton btn btn-primary prev"
                                value={getTranslation("sns.custom.jobapply.close")}
                                onClick={this.cancel} /> : ""
                        }                            
                        {globalSns.step == null ?
                            <input type="button" id="finishbutton"
                                className="FormButton btn btn-primary next"
                                value={getTranslation("sns.custom.jobapply.finish")}
                                onClick={this.finish} /> : ""
                        }
                        <a href="# " className="print" title={getTranslation("sns.custom.jobapply.print")} onClick={this.print}>
                            <span className="sr-only">{getTranslation("sns.custom.jobapply.print")}</span>
                            <i className="fa fa-print" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}
                                 
export default Overview;


// WEBPACK FOOTER //
// ./src/Components/Pages/Overview.js